import type { Location } from 'history';
import type { TFunction } from 'i18next';

/**
 * The message `Prompt` shows before leaving the page with unsaved changes. A move between the
 * page's own tabs keeps the staged changes, so it is allowed without asking.
 */
export function getUnsavedChangesPrompt(
  basePath: string,
  t: TFunction,
): (location: Location) => string | boolean {
  return (location: Location): string | boolean =>
    location.pathname === basePath || location.pathname.startsWith(`${basePath}/`)
      ? true
      : t('You have unsaved changes. Are you sure you want to leave this page?');
}

/**
 * Why the page's writes are blocked, if they are. A save and a state change both PATCH the
 * integration, so each blocks the other: a late response would show a stale state, and an edit
 * made during a state change would be overwritten when its staged edits are restored.
 */
export function getBusyReason(
  { isChangingState, isSaving }: { isChangingState: boolean; isSaving: boolean },
  t: TFunction,
): string | undefined {
  if (isSaving) {
    return t('Saving...');
  }
  return isChangingState ? t('Updating the connection...') : undefined;
}
